import React, { useState } from 'react';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import AccountBusinessAddressForm from './AccountBusinessAddressForm';
import AccountBusinessAddressList from './AccountBusinessAddressList';

function BusinessAddress(props) {

    const [showForm, setShowForm] = useState(false);
    const [editFormData, setEditFormData] = useState(null);

    const {
        handleFormSubmission,
        data,
        memberType,
        list,
        handleDispatchLocationFormSubmission,
        isLoadingList,
        handleDelete,
        handleMakeDefault,
    } = props;

    let heading, content;

    const handleEdit = (row) => {
        setShowForm(true);
        setEditFormData(row);
    };

    const handleCloseDispatchLocationForm = () => {
        setShowForm(false);
        setEditFormData(null);
    }

    const showDispatchLocationsList = memberType == 'wholesaler' || memberType == 'global member';
    //const showDispatchLocationForm = showForm && !!editFormData && showDispatchLocationsList;
    const showDispatchLocationForm = showForm && showDispatchLocationsList;

    if (memberType == 'wholesaler' || memberType == 'global member') {
        heading = <LocalizedMessage id={'ACCOUNT_BUSINESS_ADDRESS.HEADING.WHOLESALER'} />;
        content = <LocalizedMessage id={'ACCOUNT_BUSINESS_ADDRESS.CONTENT.WHOLESALER'} />;
    }
    else {
        heading = <LocalizedMessage id={'ACCOUNT_BUSINESS_ADDRESS.HEADING.RESELLER'} />;
        content = <LocalizedMessage id={'ACCOUNT_BUSINESS_ADDRESS.CONTENT.RESELLER'} />;
    }

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-freight-options' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    {heading}
                </h3>
            </div>
            <div className='vspace vspace--small'>
                <div className='text-box'>
                    <p>
                        {content}
                    </p>
                </div>
            </div>
            {showDispatchLocationsList &&
                <div className='vspace vspace--small'>
                    <AccountBusinessAddressList
                        isLoading={isLoadingList}
                        list={list}
                        onRemoveClick={handleDelete}
                        onMakeDefaultClick={handleMakeDefault}
                        onEditClick={(row) => {
                            handleEdit(row.original);
                        }}
                    />
                </div>

            }
            {!showDispatchLocationForm && showDispatchLocationsList &&
                <button
                    type='button'
                    className='button button-filter button--grey-border'
                    onClick={() => setShowForm(true)}
                >
                    <span className='icon icon-plus-thick' />
                    <span>
                        <LocalizedMessage
                            id={'ACCOUNT_ADDRESS.ADD_NEW'}
                        />
                    </span>
                </button>
            }
            {showDispatchLocationForm &&
                <div>

                    <AccountBusinessAddressForm
                        initialData={editFormData}
                        handleFormSubmission={handleDispatchLocationFormSubmission}
                        dispatchLocationID={editFormData?.ID ?? null}
                        closeForm={handleCloseDispatchLocationForm}
                    />

                </div>
            }

            {/* {showDispatchLocationForm &&
                <div className="vspace vspace--small">
                    <div className="row">
                        <div className="col-xs-12 col-md-7 vspace vspace--small">
                            <AccountBusinessAddressForm
                                initialData={editFormData}
                                handleFormSubmission={handleDispatchLocationFormSubmission}
                                dispatchLocationID={editFormData?.ID ?? null}
                                closeForm={handleCloseDispatchLocationForm}
                            />
                        </div>
                    </div>
                </div>
            } */}

            {!showDispatchLocationsList &&
                <div className="vspace vspace--small">
                    <div className="row">
                        <div className="col-xs-12 col-md-7 vspace vspace--small">
                            <AccountBusinessAddressForm
                                initialData={data}
                                handleFormSubmission={handleFormSubmission}
                            />
                        </div>
                    </div>
                </div>
            }



        </React.Fragment>
    );
}

export default BusinessAddress;
